<template>
    <v-container fluid>
        <Overlay />
        <v-row
            align="center"
            justify="center"
        >
            <v-col
                cols="11"
                class="d-flex flex-row justify-space-between align-center"
            >
                <h1>Edit Specialty</h1>
                <v-btn to="/specialty/create">
                    <v-icon
                        left
                        small
                    >
                        fas fa-plus-circle
                    </v-icon>
                    Add Specialty
                </v-btn>
            </v-col>
        </v-row>

        <v-row
            align="start"
            justify="center"
            class="d-flex flex-row justify-center"
        >
            <v-col
                cols="11"
                align="center"
                justify="center"
            >
                <ProfessionEditForm />
            </v-col>
        </v-row>
        <v-dialog
            v-model="deleteModal"
            width="500"
        >
            <v-card>
                <v-card-title>
                    <v-icon left>
                        fas fa-exclamation-triangle
                    </v-icon>
                    Delete Specialty: {{ name }}
                </v-card-title>
                <v-card-text>
                    <p>You are about to remove this specialty. This cannot be undone.</p>
                    <p>Click "Delete Specialty" to proceed.</p>
                </v-card-text>

                <v-divider />

                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        text
                        @click="toggleDeleteModal(false)"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        color="primary"
                        @click="destroy()"
                    >
                        Delete Specialty
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import ProfessionEditForm from './ProfessionEditForm';
import Overlay from '../../../../components/Overlay';
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
    components: { Overlay, ProfessionEditForm },


    computed: {
        ...mapState('professionEditor', ['deleteModal', 'name'])
    },

    methods: {
        ...mapMutations({
            toggleDeleteModal: 'professionEditor/toggleDeleteModal'
        }),

        ...mapActions({
            showNotification: 'notification/show',
            destroyData: 'professionEditor/destroyData'
        }),

        destroy() {
            this.toggleDeleteModal(false);
            this.destroyData();
        }
    }
};
</script>
